export const SAVE_USERINFO = 'save_userInfo'
export const DELETE_USERINFO = 'delete_userInfo'
export const SAVE_LOCALE = 'save_locale'
export const SAVE_MENUICON = 'save_menuIcon'
